<div class="bc-row bc-justify-content-center bc-my-5 bc-py-5">
    <div class="bc-col-auto">
        <br><br><br>
        <bc-loader
            speedLoader="2"
            sizeLoader="3xl">
        </bc-loader>
        <br><br><br>
    </div>
</div>